module.exports = __webpack_public_path__ + "img/denmark-leukaemia-female.58704f6e.png";